// extracted by mini-css-extract-plugin
export default {"wrapper":"_9879c058"};